import { ICustomerForecastDiffLastMonthBusinessData } from '../entities/customerForecastDiffLastMonth';

/**
 * 内示前月差異情報を生成するファクトリ
 */
export class ICustomerForecastDiffLastMonthBusinessDataFactory {
  /**
   * 内示前月差異情報を生成する
   * @param initialData - 初期値
   */
  public static create(initialData: Partial<ICustomerForecastDiffLastMonthBusinessData> = {}): ICustomerForecastDiffLastMonthBusinessData {
    const customerForecastDiffLastMonthBusinessData: ICustomerForecastDiffLastMonthBusinessData = {
      customerForecastStaffList: initialData.customerForecastStaffList ?? [],
      businessId: initialData.businessId ?? '-',
      supplierNumber: initialData.supplierNumber ?? '-',
      supplierName: initialData.supplierName ?? '-',
      businessNumber: initialData.businessNumber ?? '-',
      businessName: initialData.businessName ?? '-',
      package: initialData.package ?? '-',
      unit: initialData.unit ?? '-',
      manufacturer: initialData.manufacturer,
      warehouseNumber: initialData.warehouseNumber ?? '-',
      warehouse: initialData.warehouse ?? '-',
      customerNumber: initialData.customerNumber ?? '-',
      customerName: initialData.customerName ?? '-',
      salesDestinationNumber: initialData.salesDestinationNumber ?? '-',
      salesDestinationName: initialData.salesDestinationName ?? '-',
      endUser: initialData.endUser,
      salesUnitPrice: initialData.salesUnitPrice,
    };
    return customerForecastDiffLastMonthBusinessData;
  }
}
